<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('recharge.rechargeRecord')"
      @backurl="$router.back()"
    />
    <div class="item_wrap">
      <div class="item_list">
        <van-list
          v-model="loading"
          loading-text=" "
          offset="0"
          :finished="finished"
          :finished-text="$t('utils.noData')"
          @load="onLoad"
        >
          <div
            v-for="(item,index) in list"
            class="card_box item"
            :key="index"
          >
            <!-- 第一行：时间 + 状态标签 -->
            <div class="top_row">
              <span class="time_text">{{ item.act_time }}</span>
              <span 
                class="status_tag" 
                :class="{
                  'status_pending': item.status == 0,
                  'status_done': item.status == 1,
                  'status_fail': item.status == 2
                }"
              >
                <span v-if="item.status == 0">{{ $t('tabs.pending') }}</span>
                <span v-else-if="item.status == 1">{{ $t('tabs.done') }}</span>
                <span v-else-if="item.status == 2">{{ $t('tabs.fail') }}</span>
              </span>
            </div>

            <!-- 第二行：方式 + 金额 -->
            <div class="bottom_row">
              <span class="method_text">
                {{ item.name }}
                <span v-if="item.status==2" class="fail_tips">
                  <br><span class="color_red">{{ $t('recharge.rechargeFailTips') }}</span>
                </span>
              </span>
              <span class="money_text">
                {{ common.currency_symbol_basic() }}{{ common.precision_basic(item.money) }}
              </span>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import { List } from 'vant';
Vue.use(List);

export default {
  name: "RechargeRecord",
  components: {
    bsHeader
  },
  data() {
    return {
      data: [],
      empty: false,
      loading: false,
      finished: false,
      list: [],
      page: 1,
      listRows: 8
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {},
  methods: {
    sort(type) {
      this.page = 1;
      this.empty = false;
      this.list = [];
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    onLoad() {
      Fetch('/user/rechargeRecord', {
        page: this.page,
        listRows: this.listRows
      }).then(r => {
        if (r.data.length == 0) this.empty = true;
        var list = r.data.list;
        for (var i = 0; i < list.length; i++) {
          this.list.push(list[i]);
        }
        if (this.list.length >= r.data.length) {
          this.finished = true;
          return;
        }
        this.page = this.page + 1;
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  position: relative;
  padding-bottom: 60px;
  min-height: 100vh;
  /* 截图中的浅蓝网格纹理背景 */
 background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
}

.item_wrap {
  width: 100%;
  padding: 16px 0 0 0;

  .item_list {
    padding: 0 16px;

    .card_box.item {
      background: #ffffff;
      border-radius: 16px;
      padding: 16px;
      margin-bottom: 12px;
      box-shadow: 0 2px 8px rgba(24, 61, 122, 0.04);
      border: 1px solid rgba(176, 202, 240, 0.3);

      /* 第一行 (时间 + 状态标签) */
      .top_row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;

        .time_text {
          color: #64748b;
          font-size: 13px;
        }

        /* 状态标签药丸样式 */
        .status_tag {
          display: inline-flex;
          align-items: center;
          padding: 2px 12px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 600;
          
          &.status_done {
            background: #dcfce7;
            color: #16a34a;
          }
          &.status_pending {
            background: #fef9c3;
            color: #a16207;
          }
          &.status_fail {
            background: #fee2e2;
            color: #dc2626;
          }
        }
      }

      /* 第二行 (方式 + 金额) */
      .bottom_row {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .method_text {
          font-size: 15px;
          font-weight: 600;
          color: #111;
          
          .fail_tips {
            color: #64748b;
            font-weight: 400;
          }
        }

        .money_text {
          font-size: 16px;
          font-weight: 700;
          color: #111;
        }
      }
    }
  }
}

.color_red { color: #dc2626; }
</style>